import { useEffect, useState } from 'react'
import { Path, PathValue, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { BaseOptionType } from '../views/SingleCustomer/helpers/getFormSchema'
import { getCollections } from '../views/SingleRequestPage/components/SingleRequestDrawer/helpers/getCollections'

type TerritoryFields = {
  territory: string | null
  locality: string | null
  district: string | null
}

export const useTerritoryFields = <T extends TerritoryFields>(
  watch: UseFormWatch<T>,
  setValue: UseFormSetValue<T>,
  reasonId: number,
  isService?: boolean,
) => {
  const [fullDotationRegions, setFullDotationRegions] = useState<string[]>([])

  const territory = watch('territory' as Path<T>) as string
  const district = watch('district' as Path<T>) as string
  const locality = watch('locality' as Path<T>) as string

  const {
    districtOptions,
    localitiesOptions,
    localityIdx,
    districts,
    categoriesItems,
    reasonsItems,
    paymentItems,
  } = getCollections(territory, district, locality, reasonId)

  // обновляет список населенных пунктов c "полной дотацией"
  useEffect(() => {
    if (localityIdx !== -1) {
      const withFullDotation = districts[localityIdx]?.Localities?.filter(
        (el: any) => el.AllowedFinancialSourceIds.includes(1),
      )?.map((el: any) => el.Name)

      setFullDotationRegions(withFullDotation ?? [])
    }
  }, [localityIdx])

  const onDistrictChange = (value?: string) => {
    if (!localitiesOptions?.includes(value ?? district)) {
      setValue('locality' as Path<T>, null as PathValue<T, Path<T>>)
    }
  }
  // сбрасывает значения "населенного пункта" и "округ" при смене региона
  const onTerritoryChange = (value?: string) => {
    if (!districtOptions?.includes(value)) {
      setValue('district' as Path<T>, null as PathValue<T, Path<T>>)
    }
    onDistrictChange()
  }

  const onCategoriesChange = (value: BaseOptionType) => {
    const fieldName = isService ? 'preferentialCategories' : 'categories'
    const currValue = watch(fieldName as Path<T>) as number[]
    let lastIndex = categoriesItems.length - 1

    const filteredValue = currValue.filter((i, idx) => {
      return (idx === value.key && !i) || (!!i && idx !== value.key)
    })

    const newValue = currValue.map((item, index) => {
      // если нет выбраных значений выбераем "не выбрано" иначе если не нажали "не выбрано" ставим false
      const lastValue = !filteredValue.length ? true : value.key === lastIndex
      const currItem = index === value.key ? !item : item
      // если нажали "не выбрано" сбрасываем все другие значения
      const itemResetChecked = value.key === lastIndex ? false : currItem

      return index === lastIndex ? lastValue : itemResetChecked
    })

    setValue(fieldName as Path<T>, newValue as PathValue<T, Path<T>>)
  }

  return {
    onTerritoryChange,
    onDistrictChange,
    fullDotationRegions,
    reasonsItems,
    categoriesItems,
    onCategoriesChange,
    districtOptions,
    localitiesOptions,
    locality,
    district,
    territory,
    paymentItems,
  }
}
